module.exports = __webpack_public_path__ + "static/media/LockIcon.d79873cb.svg";